<template>
	<view class="box">
		<!-- 用户信息 -->
		<view class="box_user">
			<view class="box_user_box">
				<image src="@/static/uni.png" mode="widthFix"></image>
				<view class="box_user_info">
					<text class="box_user_info_name">林之秋</text>
					<view class="box_user_info_desc">
						<text>一位野生的民间咖啡师。创立于2019年，坐落于上海闵，创立于2019年</text>
						<view class="open">展开</view>
					</view>
				</view>
				<view class="box_user_submit">关注</view>
			</view>
			<view class="box_user_shop" @click="toStore">
				<view class="box_user_shop_left">
					<image src="@/static/icon/ic_mendian@2x.png" mode="widthFix"></image>
					<text>门店详情</text>
				</view>
				<uni-icons type="right" color="#333333" size="20"></uni-icons>
			</view>
		</view>
		<!-- 新鲜事列表 -->
		<view class="box_list">
			<view class="fun_list_item" v-for="(item, index) in 3" :key="index">
				<view class="fun_list_item_img">
					<image src="@/static/uni.png" mode="heightFix"></image>
				</view>
				<view class="fun_list_item_info">
					<view class="fun_list_item_info_top">
						<text>飞盘之后，新中产又被围炉煮茶割韭菜？飞盘之后，新中产又</text>
					</view>
				</view>
			</view>
		</view>
	</view>
</template>

<script>
	export default {
		data() {
			return {
				content: 'DCloud公司拥有600万开发者用户,几十万应用案例、12亿手机端月活用户，数千款uni-app插件、70+微信/qq群。阿里小程序工具官方内置uni-app（详见），腾讯课堂官方为uni-app录制培训课程（详见），开发者可以放心选择。uni-app在手，做啥都不愁。即使不跨端，uni-app也是更好的小程序开发框架（详见）、更好的App跨平台框架、更方便的H5开发框架。不管领导安排什么样的项目，你都可以快速交付，不需要转换开发思维、不需要更改开发习惯。'
			}
		},
		components: {
			
		},
		methods: {
			toStore() {
				uni.navigateTo({
					url: '/pages/storeDetails/index'
				});
			}
		}
	}
</script>

<style>
	page {
		background-color: #F5F5F5 !important;
	}
</style>

<style lang="scss" scoped>
	.box {
		width: 100%;
		.box_user {
			display: flex;
			flex-direction: column;
			min-height: 140rpx;
			background-color: #FFFFFF;
			.box_user_box {
				padding: 32rpx 32rpx 0 32rpx;
				display: flex;
				box-sizing: border-box;
				align-items: flex-start;
				image {
					width: 140rpx;
					height: 140rpx;
					border-radius: 50%;
					margin-right: 20rpx;
					flex-shrink: 0;
				}
				.box_user_info {
					flex: 1;
					min-height: 140rpx;
					display: flex;
					flex-direction: column;
					justify-content: space-between;
					.box_user_info_name {
						font-size: 36rpx;
						font-family: PingFang SC-Semibold, PingFang SC;
						font-weight: 600;
						color: #333333;
					}
					.box_user_info_desc {
						display: flex;
						align-items: flex-end;
						text {
							width: 100%;
							overflow: hidden;
							text-overflow: ellipsis;
							display: -webkit-box;
							-webkit-line-clamp: 2;
							-webkit-box-orient: vertical;
							font-size: 24rpx;
							font-family: PingFang SC-Light, PingFang SC;
							font-weight: 300;
							color: #333333;
						}
						.open {
							flex-shrink: 0;
							font-size: 24rpx;
							font-family: PingFang SC-Light, PingFang SC;
							font-weight: 300;
							color: #999999;
						}
					}
				}
				.box_user_submit {
					width: 128rpx;
					height: 48rpx;
					line-height: 48rpx;
					text-align: center;
					background: linear-gradient(270deg, #D20A0A 0%, #D95A5A 100%);
					border-radius: 27rpx;
					font-size: 28rpx;
					font-family: PingFang SC-Regular, PingFang SC;
					font-weight: 400;
					color: #FFFFFF;
					margin-left: 58rpx;
					margin-top: 46rpx;
				}
			}
			.box_user_shop {
				width: 100%;
				height: 90rpx;
				padding: 0 32rpx;
				box-sizing: border-box;
				display: flex;
				align-items: center;
				justify-content: space-between;
				border-top: 2rpx solid #F4F5F4;
				margin-top: 32rpx;
				box-shadow: 0rpx 4rpx 8rpx 0rpx rgba(0,0,0,0.04);
				.box_user_shop_left {
					display: flex;
					align-items: center;
					image {
						width: 32rpx;
						height: 32rpx;
						margin-right: 12rpx;
					}
					text {
						font-size: 28rpx;
						font-family: PingFang SC-Regular, PingFang SC;
						font-weight: 400;
						color: #333333;
					}
				}
			}
		}
		.box_list {
			padding: 0 32rpx;
			margin-top: 60rpx;
			display: flex;
			align-items: center;
			justify-content: space-between;
			flex-wrap: wrap;
			box-sizing: border-box;
			.fun_list_item {
				width: 332rpx;
				height: 540rpx;
				border-radius: 20rpx;
				background-color: white;
				overflow: hidden;
				margin-bottom: 16rpx;
				.fun_list_item_img {
					width: 100%;
					height: 420rpx;
					display: flex;
					align-items: center;
					justify-content: center;
					overflow: hidden;
					image {
						height: 100%;
					}
				}
				.fun_list_item_info {
					width: 100%;
					padding: 16rpx 12rpx 24rpx 12rpx;
					box-sizing: border-box;
					display: flex;
					flex-direction: column;
					.fun_list_item_info_top {
						width: 100%;
						-webkit-line-clamp: 2;
						display: -webkit-box;
						-webkit-box-orient: vertical;
						text-overflow: ellipsis;
						overflow: hidden;
						text {
							font-size: 28rpx;
							font-family: PingFang SC-Medium, PingFang SC;
							font-weight: 500;
							color: #333333;
						}
					}
				}
			}
		}
	}
</style>